import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { Stack } from "@phosphor-icons/react";
import { useProject } from "../context/ProjectContext";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";

// The single workspace-wide project selector. On a project workspace it also moves
// the route to the chosen project, keeping the current tab.
const PATHS = ["/projects", "/dashboard", "/scm", "/analytics"];

export default function ActiveProject() {
  const { projects, pid, setPid } = useProject();
  const loc = useLocation();
  const nav = useNavigate();
  const [params] = useSearchParams();
  const onProject = loc.pathname.startsWith("/projects/") && loc.pathname !== "/projects/new";
  if (loc.pathname === "/projects/new") return null;
  if (!PATHS.some((p) => loc.pathname.startsWith(p)) || !projects.length) return null;

  const change = (id) => {
    setPid(id);
    if (onProject) {
      const tab = params.get("tab");
      nav(`/projects/${id}${tab ? `?tab=${tab}` : ""}`);
    }
  };

  const current = onProject ? loc.pathname.split("/")[2] : pid;

  return (
    <div className="hidden md:flex items-center gap-1.5" data-testid="active-project-picker">
      <Stack size={14} className="text-[var(--c-muted)]" />
      <Select value={current} onValueChange={change}>
        <SelectTrigger data-testid="active-project-select"
          className="w-[22rem] h-8 bg-[var(--c-bg)] border-[var(--c-border)] text-[var(--c-text)] text-xs">
          <SelectValue placeholder="Active project…" />
        </SelectTrigger>
        <SelectContent className="bg-[var(--c-surface)] border-[var(--c-border)] max-h-80">
          {projects.map((p) => (
            <SelectItem key={p.id} value={p.id} className="text-[var(--c-text)] text-xs"
              data-testid={`active-project-option-${p.id.slice(0, 8)}`}>
              {`${p.project_code || p.code} — ${p.name || p.product_summary || p.client_name || "Untitled project"}`}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
